import React, { useState } from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaStepper, { KuikaStepperStep } from "../../../../ui-kit/kuika-stepper/kuika-stepper";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

const STEPS: KuikaStepperStep[] = [
  { key: "source", title: "Source", description: "Pick a file" },
  { key: "mapping", title: "Mapping", description: "Match columns" },
  { key: "review", title: "Review" },
  { key: "finish", title: "Finish" }
];

export const StepperStory: React.FC = (): JSX.Element => {
  const [current, setCurrent] = useState<number>(0);
  const [lockedCurrent, setLockedCurrent] = useState<number>(1);
  const last: number = STEPS.length - 1;

  return (
    <ShowcaseFrame
      title="Stepper"
      componentName="KuikaStepper"
      sourcePath="ui-kit/kuika-stepper"
      description="Linear wizard progress. Moving forward fills in order — rail, next node, check, pop — staggered across every step a jump passes; moving back is instant."
    >
      <SpecRow label="Forward and back" caption="Next fills one step · Jump to end staggers three · Back lands at once">
        <div style={{ width: 640 }}>
          <KuikaStepper steps={STEPS} current={current} onChange={(index: number): void => setCurrent(index)} />
        </div>
      </SpecRow>
      <SpecRow label="Controls">
        <KuikaButton type="secondary" size="sm" onClick={(): void => setCurrent(Math.max(0, current - 1))}>
          Back
        </KuikaButton>
        <KuikaButton type="primary" size="sm" onClick={(): void => setCurrent(Math.min(last, current + 1))}>
          Next
        </KuikaButton>
        <KuikaButton type="tertiary" size="sm" onClick={(): void => setCurrent(last)}>
          Jump to end
        </KuikaButton>
        <KuikaButton type="tertiary" size="sm" onClick={(): void => setCurrent(0)}>
          Restart
        </KuikaButton>
      </SpecRow>
      <SpecRow label="No jumping ahead" caption="allowJumpAhead={false} — later steps are disabled until reached">
        <div style={{ width: 640 }}>
          <KuikaStepper
            steps={STEPS}
            current={lockedCurrent}
            allowJumpAhead={false}
            onChange={(index: number): void => setLockedCurrent(index)}
          />
        </div>
      </SpecRow>
    </ShowcaseFrame>
  );
};
